import PanoramaTour from './PanoramaTour';

export default function FloorGallery() {
  return (
    <section id="floor" className="w-full py-12 md:py-16" style={{ background: '#f8f9fb' }}>
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center mb-8">
          <h3
            className="text-2xl font-light tracking-widest mb-1"
            style={{ fontFamily: "'Noto Serif JP', serif", color: '#3d8a7a' }}
          >
            FLOOR GALLERY
          </h3>
          <p className="text-gray-400 text-sm tracking-widest">店内360°ビュー</p>
        </div>

        <PanoramaTour />
      </div>
    </section>
  );
}
